// extracted by mini-css-extract-plugin
export default {"page":"YourJourneyBegins_page__pD95A"};